import { z } from "zod"
import { CreateLineItemDtoSchema } from "@mimber/schema"

export const lineItemFormSchema = CreateLineItemDtoSchema.pick({
  name: true,
  description: true,
  quantity: true,
  unitAmount: true,
}).extend({
  description: z
    .string()
    .max(1000)
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
})

export type LineItemFormData = z.infer<typeof lineItemFormSchema>
